import React from "react";
import createSvgIcon from "@material-ui/core/utils/createSvgIcon";

/**
 * author: Austin Andrews
 * id 6057DE08-41EC-4DE6-9ACC-7FB5AF3D4536
 * name elevation-decline
 * version: 1.5.54
 * url https://raw.githubusercontent.com/Templarian/MaterialDesign/master/svg/elevation-decline.svg
 * tags
 */
export const ElevationDeclineIcon = createSvgIcon(<><path d="M21,21H3V11.25L9.45,15L13.22,12.8L21,17.29V21M3,8.94V6.75L9.45,10.5L13.22,8.3L21,12.79V15L13.22,10.5L9.45,12.67L3,8.94Z" /></>, 'ElevationDeclineIcon');
export default ElevationDeclineIcon